import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_0 } from '../../colors';

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class HorizontalColumnChart extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartColor, chartId, data, isPercent } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.XYChart);
    chart.data = data;

    // -- category axis
    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'name_display';
    categoryAxis.renderer.labels.template.disabled = true;
    categoryAxis.min = 0;
    categoryAxis.numberFormatter.numberFormat = '#';
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.cellStartLocation = 0.1;
    categoryAxis.renderer.cellEndLocation = 0.9;

    // -- value axis
    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.opposite = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.min = 0;

    // -- create series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueX = 'value';
    series.dataFields.categoryY = 'name_display';
    series.name = 'entity';
    series.strokeWidth = 0;
    series.columns.template.column.cornerRadiusTopRight = 4;
    series.columns.template.column.cornerRadiusBottomRight = 4;
    series.columns.template.fill = am4core.color(chartColor);
    series.columns.template.fillOpacity = 0.8;
    series.columns.template.height = am4core.percent(100);
    series.columns.template.tooltipText = '{name_display}: [bold]{valueX}[/]';
    series.sequencedInterpolation = true;

    const valueLabel = series.bullets.push(new am4charts.LabelBullet());
    valueLabel.label.text = `{valueX}${isPercent ? '%' : ''}`;
    valueLabel.label.horizontalCenter = 'left';
    valueLabel.label.dx = 10;
    valueLabel.label.fill = am4core.color(COLOR_FONT_0);
    valueLabel.label.hideOversized = false;
    valueLabel.label.truncate = false;

    const categoryLabel = series.bullets.push(new am4charts.LabelBullet());
    categoryLabel.label.text = '{categoryY}';
    categoryLabel.label.horizontalCenter = 'right';
    categoryLabel.label.dx = -10;
    categoryLabel.label.fill = am4core.color(COLOR_FONT_0);
    categoryLabel.label.hideOversized = false;
    categoryLabel.label.truncate = false;

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: this.props.height }} />;
  }
}
